import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import permissionService from "../services/user-permission.service";
import { setMessage } from "./message";
export const fetchAllPermissionList = createAsyncThunk(
    'userPermission/fetchAllPermissionList',
    async ({ page, pagesize, search , ordering}, thunkAPI) => {
        try {
            const response = await permissionService.getAllPermissionList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);




const initialState = {
    data: [],  // Ensure the data is always an empty array initially
    list: [],
    loading: false,
    totalRecord: 0,
    totalPages: 0,
    currentPage: 1,
    status: 'idle',
    error: null,
    hasMore: true,
};

const permissionSlice = createSlice({
    name: 'userPermission',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetPermissionList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentPermissionPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllPermissionList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAllPermissionList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.data || []; // Correctly access the data array
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchAllPermissionList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });



    }
});

export const { resetPermissionList, resetCurrentPermissionPage } = permissionSlice.actions;
const { reducer } = permissionSlice;
export default reducer;
